/**
 * ProjecaoFluxo4SemWidget — projecao de fluxo de caixa nas proximas 4 semanas.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterResumoFinanceiro } from "../../../services/financeiro";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "projecao_fluxo_4sem",
  label: "Projecao 4 semanas",
  descricao: "Projecao de fluxo de caixa nas proximas 4 semanas.",
  categoria: "Financeiro",
  permissoes: ["financeiro:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterResumoFinanceiro(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const proj = dados?.projecao_4_semanas;
  if (!Array.isArray(proj) || proj.length === 0) {
    return (
      <>
        <CardBody>
          <KpiValor>—</KpiValor>
          <KpiSub>Sem projecao disponível.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/financeiro/fluxo-caixa">Ver fluxo</LinkLight>
        </CardFooter>
      </>
    );
  }
  const total = proj.reduce((s, p) => s + (Number(p.saldo) || 0), 0);
  return (
    <>
      <CardBody>
        <KpiValor>{fmt(total)}</KpiValor>
        <KpiSub>Saldo previsto em 4 semanas</KpiSub>
        <div style={{ marginTop: 6, fontSize: "0.82rem", display: "flex", flexDirection: "column", gap: 2 }}>
          {proj.slice(0, 4).map((p, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{p.label || `Sem ${i + 1}`}</span>
              <strong>{fmt(p.saldo)}</strong>
            </div>
          ))}
        </div>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/financeiro/fluxo-caixa">Ver fluxo</LinkLight>
      </CardFooter>
    </>
  );
}
